import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Table, Select, Input, Button, Tooltip, message } from "antd";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  req_page_usm_space_borrow_detail,
  req_delete_usm_space_borrow_detail,
  req_downloadfile_usm_space_borrow_detail,
} from "../../api";

class SpaceBorrowModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    space: PropTypes.object.isRequired,
  };

  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    startdate: "",
    enddate: "",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    const { SpaceCode } = this.props.space;
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      startdate,
      enddate,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_usm_space_borrow_detail(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      SpaceCode,
      startdate,
      enddate,
      token
    );

    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  api_downloadfile_items = async () => {
    const { SpaceCode } = this.props.space;
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      startdate,
      enddate,
    } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_usm_space_borrow_detail(
      userLevel,
      userCode,
      searchField,
      searchValue,
      filterStatus,
      SpaceCode,
      startdate,
      enddate,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_usm_space_borrow_detail(key, token);

    if (result.status === "success") {
      message.success("刪除成功");
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "空間編號",
        dataIndex: "RoomCode",
        width: 30,
        fixed: "left",
      },
      {
        title: "使用日期",
        dataIndex: "DateTag",
        width: 40,
      },
      {
        title: "起訖時間",
        width: 40,
        render: (item) => {
          const { TimeStart, TimeEnd } = item;
          return (
            <>
              {TimeStart} - {TimeEnd}
            </>
          );
        },
      },
      {
        title: "相關說明",
        dataIndex: "SourceDescription",
        width: 28,
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    switch (type) {
      case "EXPORT":
        this.api_downloadfile_items();
        break;
      default:
    }
    this.setState({ item: item });
  };

  //////////////////////////////////////////////////////////
  render() {
    const { loading, items, pagination, searchField, searchValue } = this.state;
    const title = (
      <>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="DateTag">借用日期</Select.Option>
        </Select>
        <Input
          placeholder="2023-01-01"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search" style={{ paddingRight: "4px" }}></i> 查詢
        </Button>{" "}
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("EXPORT", {})}
        >
          <i className="fa fa-file-excel" style={{ paddingRight: "4px" }}></i>{" "}
          匯出
        </Button>
        <p></p>
      </>
    );
    return (
      <>
        {title}
        <Card>
          <Table
            bordered
            scroll={{ x: 800, y: 380 }}
            loading={loading}
            rowKey="Uid"
            columns={this.columns}
            dataSource={items}
            onChange={this.handle_table_change}
            pagination={{
              ...pagination,
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
              // onChange: this.api_page_applycase,
              onShowSizeChange: this.handle_page_size_change,
            }}
          />
        </Card>
      </>
    );
  }
}
export default connect((state) => ({ user: state.user }), {})(SpaceBorrowModal);
